<template>
  <div class="after-sale-no-table">
    <el-input
      v-model="keyword"
      placeholder="搜索售后编号"
      size="mini"
      clearable
      @input="filter"
      style="margin-bottom: 8px"
    />

    <div class="table-box">
        <card-table
        ref="table"
        :tableID="tableId"
        :tableData="filteredData"
        :tableColumn="columns"
        :mobileColumns="mobilecolumns"
        :showIndex="true"
        :showPaging="false"
        :height="'100%'"
        :loading="loading"
        :row-class-name="rowClassName"
        @rowClick="handleRowClick"
        />
    </div>
  </div>
</template>

<script>
export default {
  name: 'afterSaleNoTable',
  props: {
    noList: Array,
    currentNo: String,
    // ✅ 后端数据未回来时表格转圈（由父组件在请求前后切换）
    loading: { type: Boolean, default: false },
    tableId: { type: String, default: 'afterSaleNoTable' }
  },
  data() {
    return {
      keyword: '',
      filteredData: [],
      mobilecolumns: [ '编号', '类型', '用户' , '地址']
    }
  },
  computed: {
    columns() {
      return [
        { prop: '编号', label: '售后编号' },
        { prop: '类型', label: '类型', minWidth: 30, width: 30 },
        { prop: '用户', label: '用户' },
        { prop: '负责人', label: '负责人'},
        { prop: '地址', label: '地址' },
        { prop: '进度', label: '进度'},
        // { prop: '合同编号', label: '合同编号' }
      ]
    }
  },
  watch: {
    noList: {
      immediate: true,
      handler(v) {
        this.filteredData = v || []
      }
    }
  },
  methods: {
filter() {
  const k = this.keyword.trim().toLowerCase()
  this.filteredData = (this.noList || []).filter(i => {
    const no = i['编号']
    return no && no.toLowerCase().includes(k)
  })
},
    handleRowClick(row) {
      this.$emit('select', row)
    },
rowClassName({ row }) {
  return row && row['编号'] === this.currentNo ? 'selected-row' : ''
}
  }
}
</script>

<style scoped>
.after-sale-no-table {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;


}

  .tab-bar {
    flex-shrink: 0;
    padding: 8px;
    border-bottom: 1px solid #ebeef5;
  }

  .table-box {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;
  }

/* ✅ 强制 card-table 内部滚动 */
::v-deep .card-table {
  height: 100% !important;
  overflow: auto !important;
}

/* ✅ 如果是 element-ui 的 el-table */
::v-deep .el-table {
  height: 100% !important;
}

::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
  overflow-x: auto !important;
}

::v-deep .el-table .selected-row td {
  background-color: rgba(37, 100, 207, 1) !important;
}

/* ✅ 强制覆盖 card-table */
.after-sale-no-table ::v-deep .card-table .el-table__header thead th {
  background-color: rgba(37, 100, 207, 0.12) !important;
}

.after-sale-no-table ::v-deep .card-table .el-table__body tbody td {
  background-color: rgba(37, 100, 207, 0.06) !important;
}

/* 滚动条区域 */
.after-sale-no-table ::v-deep .card-table .el-table__body-wrapper {
  background-color: rgba(37, 100, 207, 0.06);
}
/* ✅ 选中行：明显加深 + 白字 */
.after-sale-no-table ::v-deep .el-table__body tr.selected-row > td {
  background-color: rgba(37, 100, 207, 0.2) !important;
  /* color: #fff; */
  font-weight: 500;
}
</style>